import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, Dropdown, Form } from 'react-bootstrap';
import './MissedCallRequestModal.css';
import TauriLoader2 from '../../../TauriLoader2/TauriLoader2';
import appURL from '../../../../appURL.json'
import { getAll, getRecordById } from '../../../../localDB';
import OpalSearchInput from '../../../OpalSearchInput/OpalSearchInput';
import { accountMapping, MissedCallRequestStatus } from '../../../../visualizations/visualizations';
import { Input, Label } from 'reactstrap';
import TauriImage from '../../../TauriImage/TauriImage';

const MissedCallRequestModal = ({ show, onHide, selectedDate, request, isCreating, onProceed }) => {

    const [accounts, setAccounts] = useState([]);
    const [reasonList, setReasonList] = useState([]);
    const [selectedReason, setSelectedReason] = useState(null);

    const [errors, setErrors] = useState({});

    const handleProceed = () => {
        if (!selectedReason) return;

        const payload = {
            RequestDate: selectedDate.toLocaleDateString('en-CA'),
            ReasonID: selectedReason?.ID
        }

        onProceed?.(payload);
    };

    const fetchReasons = async () => {
        try {
            const reasons = await getAll("MissedCallReasons");
            setReasonList(reasons);
        } catch {
            return
        }
    }

    useEffect(() => {
        if (!reasonList.length) return;

        if (request?.ReasonID) {
            const selected = reasonList.find(
                reason => reason.ID === Number(request.ReasonID)
            );

            setSelectedReason(selected ?? null);
        } else {
            setSelectedReason(null);
        }
    }, [request, reasonList]);

    useEffect(() => {
        fetchReasons();
    }, [show])

    const isReadOnly = (request
        ? MissedCallRequestStatus[request.Status] !== MissedCallRequestStatus.Pending
        : false);

    return (
        <Modal
            className="create-missedcall-request-modal"
            show={show}
            onHide={onHide}
            centered
        >
            <Modal.Header className='missedcall-header'>
                MISSED CALL REQUEST
            </Modal.Header>
            <Modal.Body className='missedcall-body'>
                <Form>
                    <Form.Group className="mt-3 date-call">
                        <Form.Label>REQUESTED DATE</Form.Label>
                        <div className="d-flex align-items-center justify-content-between date-display">
                            <Form.Control
                                plaintext
                                readOnly
                                value={new Date(selectedDate).toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                })}
                                className="flex-grow-1 p-0"
                            />
                            <TauriImage localImage={"/Images/f7--calendar-today.svg"} alt='icon' color={"#000"} />
                        </div>
                    </Form.Group>

                    <Form.Group className="mt-3 reason">
                        <Form.Label>REASON</Form.Label>
                        <Dropdown >
                            <Dropdown.Toggle className="form-control text-start" disabled={isCreating ||isReadOnly}>
                                {selectedReason
                                    ? (
                                        <span>
                                            <span className='text-code '>{selectedReason.Code}</span>
                                            <span>{selectedReason.Description}</span>
                                        </span>
                                    )
                                    : "-- Select Reason --"}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="w-100">
                                {reasonList.map(reason => (
                                    <Dropdown.Item
                                        key={reason.Code}
                                        onClick={() => setSelectedReason(reason)}
                                    >
                                        <span className='text-code'>{reason.Code}</span>
                                        <span>{reason.Description}</span>
                                    </Dropdown.Item>
                                ))}
                            </Dropdown.Menu>
                        </Dropdown>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className='missedcall-footer'>
                {!isReadOnly &&
                    <Button
                        className="btn-missedcall d-flex align-items-center" onClick={handleProceed}
                        disabled={isCreating ||isReadOnly}>
                        {isCreating && (
                            <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#FFF" />
                        )}
                        <span className="text-nowrap">
                            {request ? "Update Request" : "Request"}
                        </span>
                    </Button>
                }
            </Modal.Footer>
        </Modal >
    );
};

export default MissedCallRequestModal;
